import { useEffect, useState } from "react";

// ui
import { Box } from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { PostCSVModal } from "../component/PostCSVModal";
import { ProductServiceStartStopModal } from "../component/tableFunction/ProductServiceStartStopModal";
import { DeletePaymentModal } from "../component/tableFunction/DeletePaymentModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getServices,
  getService,
  putService,
  postService,
  putServiceNoEntryFlg,
} from "../api/service";
import {
  getHighRankCompanyDeposits,
  getHighRankCompanyDeposit,
  putHighRankCompanyDeposit,
  postHighRankCompanyDeposit,
  deleteHighRankCompanyDeposit,
} from "../api/highRankCompanyDeposit";
import {
  getEntrySaleCompanyPayments,
  getEntrySaleCompanyPayment,
  putEntrySaleCompanyPayment,
  postEntrySaleCompanyPayment,
  deleteEntrySaleCompanyPayment,
} from "../api/entrySaleCompanyPayment";
import {
  getListIDs,
  putListID,
  postListID,
} from "../api/entrySaleCompanyPaymentListID";
import { getPresignedPostCSV, postPresignedPost } from "../api/presignedURL";
import {
  getSerchHighRankCompanys,
  getSerchProducts,
  getSerchSaleCompanys,
  getSerchAccountStaffs,
} from "../api/serch";

// InterFace
import { serviceTableColumn } from "../config/service";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

const postCSVColumnService = [
  "上位店名",
  "商材名",
  "サービス名",
  "サービス種類",
  "単価区分",
  "スタッフアカウント",
  "支払い開始時期",
  "チャットアプリ連携",
];

const postCSVColumnHighRankCompanyDeposit = [
  "上位店名",
  "商材名",
  "サービス名",
  "支払方法",
  "条件適応期間 - 開始",
  "取引種類",
  "戻入対象期間",
  "上位店入金単価",
];

const postCSVColumnEntrySaleCompanyPayment = [
  "上位店名",
  "商材名",
  "サービス名",
  "支払方法",
  "エントリーパートナー",
  "条件適応期間 - 開始",
  "条件適応期間 - 終了",
  "振込先パートナー",
  "リストID",
  "取引種類",
  "独自単価名",
  "トスアップパートナー",
  "戻入対象期間",
  "パートナー支払単価",
  "業務管理手数料",
  "事務手数料",
];

const putCSVColumnServiceInf = [
  "上位店名",
  "商材名",
  "サービス名",
  "変更後サービス名",
  "変更後スタッフアカウント",
];

function Service() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "サービスプラン登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "サービスプラン登録CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "上位店入金単価登録CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "パートナー支払単価登録CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "サービス名・スタッフアカウントCSV変更",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "サービスプラン登録") {
      getFirstYear();
      getOneYear();
      setOnDataAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "サービスプラン登録CSV取込") {
      setPostServiceCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "上位店入金単価登録CSV取込") {
      setPostHighRankCompanyDepositCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "パートナー支払単価登録CSV取込") {
      setPostEntrySaleCompanyPaymentCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "サービス名・スタッフアカウントCSV変更") {
      setPutServiceInfCSV({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "入金単価一覧") {
      getSubtableDataHighRankCompanyDeposit();
    }
    if (getSubTableName.name === "パートナー一覧") {
      getSubtableDataEntrySaleCompanyPayment();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {
    if (getSubTableDetail.name === "上位店入金単価詳細") {
      getSubtableDataDetailHighRankCompanyDeposit();
    }
    if (getSubTableDetail.name === "パートナー支払単価詳細") {
      getSubtableDataDetailEntrySaleCompanyPayment();
    }
  }, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "入金単価追加") {
      openModalSubtableDataAddHighRankCompanyDeposit();
    }
    if (getSubTableAdd.name === "パートナー追加") {
      openModalSubtableDataAddEntrySaleCompanyPayment();
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubSubTableName.name === "リストID一覧") {
      getSubSubtableDataListID();
    }
  }, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubSubTableDetail, setGetSubSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {}, [getSubSubTableDetail.name, getSubSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubSubTableAdd.name === "リストID追加") {
      openModalSubSubtableDataAddListID();
    }
  }, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "取扱い停止・再開") {
      setStartStopDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "入金単価一覧") {
      // 上位店入金単価の削除
      setDeleteHighRankCompanyDepositInf({
        status: "open",
        name: "上位店入金単価の削除",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "パートナー一覧") {
      // パートナー支払単価の削除
      setDeleteEntrySaleCompanyPaymentInf({
        status: "open",
        name: "パートナー支払単価の削除",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();
  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  // データ編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);

  // データ新規作成
  const addDataColumns = serviceTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (difine.addType === "date") {
          return {
            ...column,
            [difine.key + "_year"]: thisYear.toString(),
            [difine.key + "_month"]: thisMonth.toString(),
            [difine.key + "_date"]: "1",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [addData, setAddData] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumns);
  const [onDataAddModal, setOnDataAddModal] = useState(false);
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = serviceTableColumn.dataColumn.reduce((column, difine) => {
    if (difine.serch === true) {
      if (difine.serchType === "date") {
        return {
          ...column,
          [difine.key + "_start"]: "",
          [difine.key + "_end"]: "",
          no_entry_flg: "通常",
        };
      } else if (difine.serchType === "payment_year_month") {
        return {
          ...column,
          payment_year: thisYear.toString(),
          payment_month: thisMonth.toString(),
          no_entry_flg: "通常",
        };
      } else {
        return {
          ...column,
          [difine.key]: "",
          no_entry_flg: "通常",
        };
      }
    } else {
      return {
        ...column,
      };
    }
  }, {}) as { [key: string]: string };
  const [serchString, setSerchString] = useState<{ [key: string]: string }>(serchColumn);
  const [serchStringView, setSerchStringView] = useState<{ [key: string]: string }>(serchColumn);

  // 顧客一覧取得
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getServices({
      ...serchString,
      deposit_start_date_start: serchString.deposit_start_date_start ?? "",
      deposit_start_date_end: serchString.deposit_start_date_end ?? "",
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.services);
      const countServices = Number(fetchData.countServices);
      setTotalCount(countServices);
      setMaxPageNumber(Math.ceil(countServices / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 顧客詳細取得
  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const payment_method_id = key.payment_method_id;
    const { detail_data } = await getService(id, payment_method_id);
    setDataDetail(detail_data);
    if (!edit) {
      setIsLoading(false);
    }
  }

  // 顧客編集
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      const payment_method_id = editData.payment_method_id as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putService(editData);
      await getDataDetail({ id, payment_method_id }, true);
      await getTableData(true);
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 顧客新規登録
  async function postAddData() {
    setIsLoading(true);
    setOnDataAddModal(false);
    const postResponce = await postService(addData);
    if (postResponce === "success") {
      await getTableData(true);
      setAddData(addDataColumns);
      setOnDataAddModalResult("success");
    } else {
      setOnDataAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 取扱い停止・再開
  const [startStopDataInf, setStartStopDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function startStopData() {
    setStartStopDataInf({
      ...startStopDataInf,
      status: "loading",
    });
    const id = startStopDataInf.key.id;
    const startStop = startStopDataInf.key.startStop;
    const responce = await putServiceNoEntryFlg(id, startStop);
    if (responce == "success") {
      await getTableData(false);
      setStartStopDataInf({
        ...startStopDataInf,
        status: "success",
      });
    } else {
      setStartStopDataInf({
        ...startStopDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (startStopDataInf.status === "loading") {
      setIsLoading(true);
    } else if (startStopDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [startStopDataInf]);

  // 上位店入金単価の削除
  const [deleteHighRankCompanyDepositInf, setDeleteHighRankCompanyDepositInf] =
    useState<{
      status: null | "loading" | "open" | "success" | "failed";
      key: { [key: string]: string };
      name: string;
      message: string;
    }>({
      status: null,
      name: "",
      key: {},
      message: "",
    });
  async function deleteHighRankCompanyDepositFunc() {
    setDeleteHighRankCompanyDepositInf({
      ...deleteHighRankCompanyDepositInf,
      status: "loading",
    });
    const id = deleteHighRankCompanyDepositInf.key.id;
    const responce = await deleteHighRankCompanyDeposit(id);
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataHighRankCompanyDeposit();
      setDeleteHighRankCompanyDepositInf({
        ...deleteHighRankCompanyDepositInf,
        status: "success",
      });
    } else {
      setDeleteHighRankCompanyDepositInf({
        ...deleteHighRankCompanyDepositInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteHighRankCompanyDepositInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteHighRankCompanyDepositInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteHighRankCompanyDepositInf]);

  // パートナー支払単価の削除
  const [
    deleteEntrySaleCompanyPaymentInf,
    setDeleteEntrySaleCompanyPaymentInf,
  ] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    name: string;
    message: string;
  }>({
    status: null,
    name: "",
    key: {},
    message: "",
  });
  async function deleteEntrySaleCompanyPaymentFunc() {
    setDeleteEntrySaleCompanyPaymentInf({
      ...deleteEntrySaleCompanyPaymentInf,
      status: "loading",
    });
    const id = deleteEntrySaleCompanyPaymentInf.key.id;
    const entry_sale_company_table_id =
      deleteEntrySaleCompanyPaymentInf.key.entry_sale_company_table_id;
    const responce = await deleteEntrySaleCompanyPayment(
      id,
      entry_sale_company_table_id
    );
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataEntrySaleCompanyPayment();
      setDeleteEntrySaleCompanyPaymentInf({
        ...deleteEntrySaleCompanyPaymentInf,
        status: "success",
      });
    } else {
      setDeleteEntrySaleCompanyPaymentInf({
        ...deleteEntrySaleCompanyPaymentInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteEntrySaleCompanyPaymentInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteEntrySaleCompanyPaymentInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteEntrySaleCompanyPaymentInf]);

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[]
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        }
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  // 上位店一覧取得
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[]
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        }
      );
      setProductNameList(productNameList);
    }
  }

  // サービス新規登録時、選択した上位店により商材一覧
  const [selectProductList, setSelectProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  useEffect(() => {
    let selectProductList: {
      id: number;
      high_rank_company_id: number;
      product_name: string;
    }[] = [];
    const high_rank_company_id = Number(addData.high_rank_company_id);
    productList.map((product) => {
      if (product.high_rank_company_id === high_rank_company_id) {
        selectProductList.push(product);
      }
    });
    setSelectProductList(selectProductList);
  }, [addData]);

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[]
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        }
      );
      setCampanyNameList(companyNameList);
    }
  }

  // スタッフアカウント一覧
  const [staffList, setStaffList] = useState<
    { id: number; account_name: string }[]
  >([]);
  // スタッフアカウント一覧取得
  async function getStaffList() {
    const fetchData = await getSerchAccountStaffs();
    if (fetchData === null) {
      setStaffList([]);
    } else if (fetchData) {
      setStaffList(
        fetchData.accountStaffs as { id: number; account_name: string }[]
      );
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getProductList();
    getSaleCompanysList();
    getStaffList();
  }, []);

  // サービスプラン登録CSV取込
  const [postServiceCSVStatus, setPostServiceCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postServiceCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postServiceCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postServiceCSVStatus]);
  async function postServicesCSV(postDatas: File) {
    setPostServiceCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostServiceCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "service";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostServiceCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postServiceCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPostServiceCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postServiceCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostServiceCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postServiceCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostServiceCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // サービス名・スタッフアカウントCSV変更
  const [putServiceInfCSV, setPutServiceInfCSV] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (putServiceInfCSV.status === "loading") {
      setIsLoading(true);
    } else if (putServiceInfCSV.status !== "none") {
      setIsLoading(false);
    }
  }, [putServiceInfCSV]);
  async function putServicesCSV(postDatas: File) {
    setPutServiceInfCSV({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPutServiceInfCSV({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "serviceInf";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPutServiceInfCSV({
          status: "loading",
          message: "CSV取込完了",
          result: putServiceInfCSV.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPutServiceInfCSV({
          status: "result",
          message: "CSV取込完了",
          result: putServiceInfCSV.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPutServiceInfCSV({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = putServiceInfCSV.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPutServiceInfCSV({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // 上位店入金単価一覧取得（検索条件はバックエンドで絞り込み）
  async function getSubtableDataHighRankCompanyDeposit() {
    if (getSubTableName.key.id && getSubTableName.key.payment_method_id) {
      setIsLoading(true);
      const fetchData = await getHighRankCompanyDeposits(
        getSubTableName.key.id,
        getSubTableName.key.payment_method_id,
        {
          deposit_start_date_start: serchString.deposit_start_date_start,
          deposit_start_date_end: serchString.deposit_start_date_end,
        }
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas ?? [],
      });
      setIsLoading(false);
    }
  }

  // 上位店入金単価詳細取得
  async function getSubtableDataDetailHighRankCompanyDeposit() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getHighRankCompanyDeposit(
        getSubTableDetail.key.id
      );
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // 上位店入金単価編集
  const [
    editDataDetailHighRankCompanyDeposit,
    setEditDataDetailHighRankCompanyDeposit,
  ] = useState<EditDataDifine | null>(null);
  async function putEditDataDetailHighRankCompanyDeposit() {
    if (editDataDetailHighRankCompanyDeposit !== null) {
      setIsLoading(true);
      setEditDataDetailHighRankCompanyDeposit({
        ...editDataDetailHighRankCompanyDeposit,
        status: "editing",
      });
      const putResponce = await putHighRankCompanyDeposit(
        editDataDetailHighRankCompanyDeposit
      );
      if (putResponce == "success") {
        await getSubtableDataHighRankCompanyDeposit();
        await getSubtableDataDetailHighRankCompanyDeposit();
      }
      setEditDataDetailHighRankCompanyDeposit({
        ...editDataDetailHighRankCompanyDeposit,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 上位店入金単価新規登録
  const addDataColumnsHighRankCompanyDeposit =
    serviceTableColumn.subTable[0].subDataColumn.reduce((column, difine) => {
      if (difine.add) {
        if (difine.addType === "date") {
          return {
            ...column,
            [difine.key + "_year"]: thisYear.toString(),
            [difine.key + "_month"]: thisMonth.toString(),
            [difine.key + "_date"]: "1",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    }, {});
  const [addDataHighRankCompanyDeposit, setAddDataHighRankCompanyDeposit] =
    useState<{
      [key: string]: string | boolean | any[];
    }>(addDataColumnsHighRankCompanyDeposit);
  const [
    onDataAddModalHighRankCompanyDeposit,
    setOnDataAddModalHighRankCompanyDeposit,
  ] = useState(false);
  async function openModalSubtableDataAddHighRankCompanyDeposit() {
    let _addDataHighRankCompanyDeposit = addDataHighRankCompanyDeposit;
    serviceTableColumn.subTable[0].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataHighRankCompanyDeposit[difine.key] =
            getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataHighRankCompanyDeposit[difine.key] =
            getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataHighRankCompanyDeposit[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataHighRankCompanyDeposit(_addDataHighRankCompanyDeposit);
    if (getSubTableAdd.row) {
      setOnDataAddModalHighRankCompanyDeposit(true);
    }
  }
  async function postAddDataHighRankCompanyDeposit() {
    setIsLoading(true);
    setOnDataAddModalHighRankCompanyDeposit(false);
    const postResponce = await postHighRankCompanyDeposit(
      addDataHighRankCompanyDeposit
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "入金単価一覧") {
        await getSubtableDataHighRankCompanyDeposit();
      }
      await getTableData(true);
      setAddDataHighRankCompanyDeposit(addDataColumnsHighRankCompanyDeposit);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalHighRankCompanyDeposit(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 上位店入金単価登録CSV取込
  const [
    postHighRankCompanyDepositCSVStatus,
    setPostHighRankCompanyDepositCSVStatus,
  ] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postHighRankCompanyDepositCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postHighRankCompanyDepositCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postHighRankCompanyDepositCSVStatus]);
  async function postHighRankCompanyDepositsCSV(postDatas: File) {
    setPostHighRankCompanyDepositCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostHighRankCompanyDepositCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "highRankCompanyDeposit";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostHighRankCompanyDepositCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postHighRankCompanyDepositCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        if (getSubTableName.name == "入金単価一覧") {
          await getSubtableDataHighRankCompanyDeposit();
        }
        setPostHighRankCompanyDepositCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postHighRankCompanyDepositCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostHighRankCompanyDepositCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postHighRankCompanyDepositCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostHighRankCompanyDepositCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // パートナー支払単価一覧取得（検索条件はバックエンドで絞り込み）
  async function getSubtableDataEntrySaleCompanyPayment() {
    if (getSubTableName.key.id && getSubTableName.key.payment_method_id) {
      setIsLoading(true);
      const fetchData = await getEntrySaleCompanyPayments(
        getSubTableName.key.id,
        getSubTableName.key.payment_method_id,
        {
          entry_sale_company_name: serchString.entry_sale_company_name,
          payment_sale_company_name: serchString.payment_sale_company_name,
          toss_up_company_name: serchString.toss_up_company_name,
          deposit_start_date_start: serchString.deposit_start_date_start,
          deposit_start_date_end: serchString.deposit_start_date_end,
        }
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas ?? [],
      });
      setIsLoading(false);
    }
  }

  // 検索条件（条件適応期間・各パートナー）変更時にサブテーブルを再取得
  useEffect(() => {
    if (getSubTableName.name === "入金単価一覧") {
      getSubtableDataHighRankCompanyDeposit();
    }
    if (getSubTableName.name === "パートナー一覧") {
      getSubtableDataEntrySaleCompanyPayment();
    }
  }, [
    serchString.deposit_start_date_start,
    serchString.deposit_start_date_end,
    serchString.entry_sale_company_name,
    serchString.payment_sale_company_name,
    serchString.toss_up_company_name,
  ]);

  // パートナー支払単価詳細取得
  async function getSubtableDataDetailEntrySaleCompanyPayment() {
    if (
      getSubTableDetail.key.id &&
      getSubTableDetail.key.entry_sale_company_table_id &&
      getSubTableDetail.key.payment_method_id
    ) {
      setIsLoading(true);
      const dataDetail = await getEntrySaleCompanyPayment(
        getSubTableDetail.key.id,
        getSubTableDetail.key.entry_sale_company_table_id,
        getSubTableDetail.key.payment_method_id
      );
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // パートナー支払単価編集
  const [
    editDataDetailEntrySaleCompanyPayment,
    setEditDataDetailEntrySaleCompanyPayment,
  ] = useState<EditDataDifine | null>(null);
  async function putEditDataDetailEntrySaleCompanyPayment() {
    if (editDataDetailEntrySaleCompanyPayment !== null) {
      setIsLoading(true);
      setEditDataDetailEntrySaleCompanyPayment({
        ...editDataDetailEntrySaleCompanyPayment,
        status: "editing",
      });
      const putResponce = await putEntrySaleCompanyPayment(
        editDataDetailEntrySaleCompanyPayment
      );
      if (putResponce == "success") {
        await getSubtableDataEntrySaleCompanyPayment();
        await getSubtableDataDetailEntrySaleCompanyPayment();
      }
      setEditDataDetailEntrySaleCompanyPayment({
        ...editDataDetailEntrySaleCompanyPayment,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // パートナー支払単価新規登録
  const addDataColumnsEntrySaleCompanyPayment =
    serviceTableColumn.subTable[1].subDataColumn.reduce((column, difine) => {
      if (difine.add) {
        if (difine.addType === "date") {
          return {
            ...column,
            [difine.key + "_year"]: thisYear.toString(),
            [difine.key + "_month"]: thisMonth.toString(),
            [difine.key + "_date"]: "1",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
            payment_end_date_post: true,
          };
        }
      } else {
        return {
          ...column,
          payment_end_date_post: true,
        };
      }
    }, {});
  const [addDataEntrySaleCompanyPayment, setAddDataEntrySaleCompanyPayment] =
    useState<{
      [key: string]: string | boolean | any[];
    }>(addDataColumnsEntrySaleCompanyPayment);
  const [
    onDataAddModalEntrySaleCompanyPayment,
    setOnDataAddModalEntrySaleCompanyPayment,
  ] = useState(false);
  async function openModalSubtableDataAddEntrySaleCompanyPayment() {
    let _addDataEntrySaleCompanyPayment = addDataEntrySaleCompanyPayment;
    serviceTableColumn.subTable[1].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataEntrySaleCompanyPayment[difine.key] =
            getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataEntrySaleCompanyPayment[difine.key] =
            getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataEntrySaleCompanyPayment[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataEntrySaleCompanyPayment(_addDataEntrySaleCompanyPayment);
    if (getSubTableAdd.row) {
      setOnDataAddModalEntrySaleCompanyPayment(true);
    }
  }
  async function postAddDataEntrySaleCompanyPayment() {
    setIsLoading(true);
    setOnDataAddModalEntrySaleCompanyPayment(false);
    const postResponce = await postEntrySaleCompanyPayment(
      addDataEntrySaleCompanyPayment
    );
    if (postResponce === "success") {
      setAddDataEntrySaleCompanyPayment(addDataColumnsEntrySaleCompanyPayment);
      await getTableData(true);
      if (getSubTableName.name === "パートナー一覧") {
        await getSubtableDataEntrySaleCompanyPayment();
      }
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalEntrySaleCompanyPayment(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // パートナー支払単価登録CSV取込
  const [
    postEntrySaleCompanyPaymentCSVStatus,
    setPostEntrySaleCompanyPaymentCSVStatus,
  ] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postEntrySaleCompanyPaymentCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postEntrySaleCompanyPaymentCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postEntrySaleCompanyPaymentCSVStatus]);
  async function postEntrySaleCompanyPaymentsCSV(postDatas: File) {
    setPostEntrySaleCompanyPaymentCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostEntrySaleCompanyPaymentCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "entrySaleCompanyPayment";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostEntrySaleCompanyPaymentCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postEntrySaleCompanyPaymentCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        if (getSubTableName.name === "パートナー一覧") {
          await getSubtableDataEntrySaleCompanyPayment();
        }
        setPostEntrySaleCompanyPaymentCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postEntrySaleCompanyPaymentCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostEntrySaleCompanyPaymentCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postEntrySaleCompanyPaymentCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostEntrySaleCompanyPaymentCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // リストID一覧取得
  async function getSubSubtableDataListID() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getListIDs(getSubSubTableName.key.id);
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // リストID編集
  const [editDataDetailListID, setEditDataDetailListID] =
    useState<EditDataDifine | null>(null);
  async function putEditDataDetailListID() {
    if (editDataDetailListID !== null) {
      setIsLoading(true);
      setEditDataDetailListID({
        ...editDataDetailListID,
        status: "editing",
      });
      const putResponce = await putListID(editDataDetailListID);
      if (putResponce == "success") {
        await getSubSubtableDataListID();
      }
      setEditDataDetailListID({
        ...editDataDetailListID,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // リストID新規登録
  const addDataColumnsListID =
    serviceTableColumn.subTable[1].subTable[0].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          if (difine.addType === "date") {
            return {
              ...column,
              [difine.key + "_year"]: thisYear.toString(),
              [difine.key + "_month"]: thisMonth.toString(),
              [difine.key + "_date"]: "1",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
              payment_end_date_post: true,
            };
          }
        } else {
          return {
            ...column,
            payment_end_date_post: true,
          };
        }
      },
      {}
    );
  const [addDataListID, setAddDataListID] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsListID);
  const [onDataAddModalListID, setOnDataAddModalListID] = useState(false);
  async function openModalSubSubtableDataAddListID() {
    let _addDataListID = addDataListID;
    serviceTableColumn.subTable[1].subTable[0].subDataColumn.map((difine) => {
      if (difine.add && getSubSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataListID[difine.key] = getSubSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataListID[difine.key] =
            getSubSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataListID[difine.key] = getSubSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataListID(_addDataListID);
    if (getSubSubTableAdd.row) {
      setOnDataAddModalListID(true);
    }
  }
  async function postAddDataListID() {
    setIsLoading(true);
    setOnDataAddModalListID(false);
    const postResponce = await postListID(addDataListID);
    if (postResponce === "success") {
      await getTableData(true);
      if (getSubSubTableName.name === "リストID一覧") {
        await getSubSubtableDataListID();
      }
      if (getSubTableName.name === "パートナー一覧") {
        await getSubtableDataEntrySaleCompanyPayment();
      }
      setAddDataListID(addDataColumnsListID);
      setOnSubSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalListID(true);
      setOnSubSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 排他制御: 検索とAIチャットは同時に開かない
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      data-testid="service-page"
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
        addDataTestIds={addDataTypes.map((dt) => `add-button-${dt.name}`)}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            {/* E2E: table-row-${index} applied to each data row */}
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={serviceTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={getSubTableDetail}
              setGetSubTableDetail={setGetSubTableDetail}
              setGetSubTableAdd={setGetSubTableAdd}
              getSubSubTableName={getSubSubTableName}
              setGetSubTableEditDirect={() => {}}
              setGetSubSubTableName={setGetSubSubTableName}
              getSubSubTableDetail={getSubSubTableDetail}
              setGetSubSubTableDetail={setGetSubSubTableDetail}
              setGetSubSubTableAdd={setGetSubSubTableAdd}
              setGetSubSubTableEditDirect={setEditDataDetailListID}
              tableTitle={serviceTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={() => {}}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={serviceTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={[]}
            productNameList={productNameList}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="Service"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={serviceTableColumn.detailTitle}
        editAuth={serviceTableColumn.editAuth}
        dataColumn={serviceTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            serviceTableColumn.subTable[0].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editDataDetailHighRankCompanyDeposit !== null &&
            editDataDetailHighRankCompanyDeposit.status !== "editing") ||
            editDataDetailHighRankCompanyDeposit === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={serviceTableColumn.subTable[0].subTableDetailTitle}
        editAuth={serviceTableColumn.subTable[0].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={serviceTableColumn.subTable[0].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditDataDetailHighRankCompanyDeposit}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            serviceTableColumn.subTable[1].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editDataDetailEntrySaleCompanyPayment !== null &&
            editDataDetailEntrySaleCompanyPayment.status !== "editing") ||
            editDataDetailEntrySaleCompanyPayment === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={serviceTableColumn.subTable[1].subTableDetailTitle}
        editAuth={serviceTableColumn.subTable[1].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={serviceTableColumn.subTable[1].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditDataDetailEntrySaleCompanyPayment}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataDetailModal
        onModal={
          getSubSubTableDetail.name ===
            serviceTableColumn.subTable[1].subTable[0].subTableDetailTitle &&
          getSubSubTableDetail.dataDetail !== null &&
          ((editDataDetailListID !== null &&
            editDataDetailListID.status !== "editing") ||
            editDataDetailListID === null)
        }
        swCloseModal={() =>
          setGetSubSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={
          serviceTableColumn.subTable[1].subTable[0].subTableDetailTitle
        }
        editAuth={serviceTableColumn.subTable[1].subTable[0].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={serviceTableColumn.subTable[1].subTable[0].subDataColumn}
        dataDetail={getSubSubTableDetail.dataDetail}
        setEditData={setEditDataDetailListID}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailHighRankCompanyDeposit !== null &&
          editDataDetailHighRankCompanyDeposit.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailHighRankCompanyDeposit(null)}
        editData={editDataDetailHighRankCompanyDeposit}
        setEditData={setEditDataDetailHighRankCompanyDeposit}
        putEditData={putEditDataDetailHighRankCompanyDeposit}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailEntrySaleCompanyPayment !== null &&
          editDataDetailEntrySaleCompanyPayment.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailEntrySaleCompanyPayment(null)}
        editData={editDataDetailEntrySaleCompanyPayment}
        setEditData={setEditDataDetailEntrySaleCompanyPayment}
        putEditData={putEditDataDetailEntrySaleCompanyPayment}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailListID !== null &&
          editDataDetailListID.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailListID(null)}
        editData={editDataDetailListID}
        setEditData={setEditDataDetailListID}
        putEditData={putEditDataDetailListID}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onDataAddModal}
        swCloseModal={() => {
          setOnDataAddModal(false);
          setAddDataName("");
        }}
        addTitle={serviceTableColumn.addTitle}
        dataColumn={serviceTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        companyList={companyList}
        highRankCompanyList={highRankCompanyList}
        staffList={staffList}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalHighRankCompanyDeposit}
        swCloseModal={() => {
          setOnDataAddModalHighRankCompanyDeposit(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={serviceTableColumn.subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={serviceTableColumn.subTable[0].subDataColumn}
        postAddData={postAddDataHighRankCompanyDeposit}
        addData={addDataHighRankCompanyDeposit}
        setAddData={setAddDataHighRankCompanyDeposit}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalEntrySaleCompanyPayment}
        swCloseModal={() => {
          setOnDataAddModalEntrySaleCompanyPayment(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={serviceTableColumn.subTable[1].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={serviceTableColumn.subTable[1].subDataColumn}
        postAddData={postAddDataEntrySaleCompanyPayment}
        addData={addDataEntrySaleCompanyPayment}
        setAddData={setAddDataEntrySaleCompanyPayment}
        companyList={companyList}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalListID}
        swCloseModal={() => {
          setOnDataAddModalListID(false);
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={serviceTableColumn.subTable[1].subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={serviceTableColumn.subTable[1].subTable[0].subDataColumn}
        postAddData={postAddDataListID}
        addData={addDataListID}
        setAddData={setAddDataListID}
        companyList={companyList}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubSubtableDataAddModalResult("");
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubSubtableDataAddModalResult}
      />
      <PostCSVModal
        onModal={
          postServiceCSVStatus.status !== "none" &&
          postServiceCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostServiceCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postServiceCSVStatus}
        setPostCSVStatus={setPostServiceCSVStatus}
        postCSVFunc={postServicesCSV}
        postCSVTitle={serviceTableColumn.postCSVTitle}
        postCSVColumn={postCSVColumnService}
        postCSVColumnResult={postCSVColumnService}
        postCSVPath="service"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          putServiceInfCSV.status !== "none" &&
          putServiceInfCSV.status !== "loading"
        }
        swCloseModal={() => {
          setPutServiceInfCSV({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={putServiceInfCSV}
        setPostCSVStatus={setPutServiceInfCSV}
        postCSVFunc={putServicesCSV}
        postCSVTitle={"サービス名・スタッフアカウントCSV変更"}
        postCSVColumn={putCSVColumnServiceInf}
        postCSVColumnResult={putCSVColumnServiceInf}
        postCSVPath="serviceInf"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postHighRankCompanyDepositCSVStatus.status !== "none" &&
          postHighRankCompanyDepositCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostHighRankCompanyDepositCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postHighRankCompanyDepositCSVStatus}
        setPostCSVStatus={setPostHighRankCompanyDepositCSVStatus}
        postCSVFunc={postHighRankCompanyDepositsCSV}
        postCSVTitle={"上位店入金単価登録CSV取込"}
        postCSVColumn={postCSVColumnHighRankCompanyDeposit}
        postCSVColumnResult={postCSVColumnHighRankCompanyDeposit}
        postCSVPath="highRankCompanyDeposit"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postEntrySaleCompanyPaymentCSVStatus.status !== "none" &&
          postEntrySaleCompanyPaymentCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostEntrySaleCompanyPaymentCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postEntrySaleCompanyPaymentCSVStatus}
        setPostCSVStatus={setPostEntrySaleCompanyPaymentCSVStatus}
        postCSVFunc={postEntrySaleCompanyPaymentsCSV}
        postCSVTitle={"パートナー支払単価登録CSV取込"}
        postCSVColumn={postCSVColumnEntrySaleCompanyPayment}
        postCSVColumnResult={postCSVColumnEntrySaleCompanyPayment}
        postCSVPath="entrySaleCompanyPayment"
        productList={[]}
        categoryList={[]}
      />
      <ProductServiceStartStopModal
        onModal={
          startStopDataInf.status !== null &&
          startStopDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setStartStopDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        startStopDataInf={startStopDataInf}
        setStartStopDataInf={setStartStopDataInf}
        startStopData={startStopData}
      />
      <DeletePaymentModal
        onModal={
          deleteHighRankCompanyDepositInf.status !== null &&
          deleteHighRankCompanyDepositInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteHighRankCompanyDepositInf({
            status: null,
            name: "",
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePaymentInf={deleteHighRankCompanyDepositInf}
        setDeletePaymentInf={setDeleteHighRankCompanyDepositInf}
        deletePayment={deleteHighRankCompanyDepositFunc}
      />
      <DeletePaymentModal
        onModal={
          deleteEntrySaleCompanyPaymentInf.status !== null &&
          deleteEntrySaleCompanyPaymentInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteEntrySaleCompanyPaymentInf({
            status: null,
            name: "",
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePaymentInf={deleteEntrySaleCompanyPaymentInf}
        setDeletePaymentInf={setDeleteEntrySaleCompanyPaymentInf}
        deletePayment={deleteEntrySaleCompanyPaymentFunc}
      />
    </Box>
  );
}

export default Service;
